module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reinit_column_name":"Reinitialize to default value"},"fr":{"reinit_column_name":"Réinitaliser à la valeur par défaut"}}')
  delete Component.options._Ctor
}
